import React, { useEffect, useState } from 'react';
import { callJamboProxy, getStoredShop, setStoredShop } from '../../utils/tianlanStore';

function TianlanStoreSwitcher({ compact = false }) {
  const [shop, setShop] = useState(getStoredShop());
  const [carts, setCarts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadCarts = async () => {
    setIsLoading(true);
    try {
      const result = await callJamboProxy('listCarts', {}, shop);
      const nextCarts = result.carts || [];
      setCarts(nextCarts);
      if (nextCarts.length > 0 && !nextCarts.some(cart => (cart.shopUserId || cart.shop_user_id) === shop.shopUserId)) {
        const first = nextCarts[0];
        const firstShopUserId = first.shopUserId || first.shop_user_id;
        setShop(setStoredShop({
          shopUserId: firstShopUserId,
          storeId: firstShopUserId,
          storeName: first.storeName || first.store_name,
        }));
      }
    } catch (error) {
      console.error('載入直播商店失敗:', error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadCarts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (shopUserId) => {
    const cart = carts.find(item => (item.shopUserId || item.shop_user_id) === shopUserId);
    const nextShop = setStoredShop({
      shopUserId,
      storeId: shopUserId,
      storeName: cart?.storeName || cart?.store_name || `商店 ${shopUserId}`,
    });
    setShop(nextShop);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: compact ? '0' : '10px 12px',
      background: compact ? 'transparent' : '#f8fafc',
      border: compact ? 'none' : '1px solid #e5e7eb',
      borderRadius: '10px',
      flexWrap: 'wrap'
    }}>
      <span style={{ fontSize: '13px', color: '#64748b' }}>目前商店</span>
      <select
        value={shop.shopUserId}
        onChange={(e) => handleChange(e.target.value)}
        disabled={isLoading}
        style={{
          minWidth: '160px',
          padding: '8px 10px',
          border: '1px solid #cbd5e1',
          borderRadius: '8px',
          background: '#fff'
        }}
      >
        {carts.length === 0 && <option value={shop.shopUserId}>{shop.storeName}</option>}
        {carts.map(cart => {
          const shopUserId = cart.shopUserId || cart.shop_user_id;
          return (
          <option key={cart.id || cart.docId || shopUserId} value={shopUserId}>
            {cart.storeName || cart.store_name || `商店 ${shopUserId}`}{cart.authExpired ? '（需重登）' : ''}
          </option>
          );
        })}
      </select>
      {!compact && (
        <button type="button" onClick={loadCarts} disabled={isLoading} className="action-btn secondary">
          {isLoading ? '更新中...' : '重新整理商店'}
        </button>
      )}
    </div>
  );
}

export default TianlanStoreSwitcher;
